import React from 'react';
import ReactDOM from 'react-dom';
import { string } from 'prop-types';
import { MicroApp, peerDependencies } from '@gcc/autobahn-micro-app';
import * as styled from 'styled-components';

// Expose micro app peer dependencies.
peerDependencies(React, ReactDOM, styled);

const App = ({ mode }) => (
  <div style={{ display: 'none' }}>
    <MicroApp
      config={{
        View: {
          Name: 'newsletter-sign-up',
          Version: '0.3.299',
        },
        mode,
      }}
    />
  </div>
);

App.propTypes = {
  mode: string,
};

App.defaultProps = {
  mode: 'light',
};

export default App;
